import { Injectable } from '@angular/core';
import { map, Observable, of, switchMap, take } from 'rxjs';
import { ApolloClientService } from './apollo-client.service';
import { HttpClient } from '@angular/common/http';
import { GET_VEHICLE_FUNCTIONS_QUERY } from 'src/app/graphQL/queries/vehicle-functions-queries';
import { VehicleFunction, VehicleFunctionBase } from 'src/app/models/dto/vehicleFunctionDto';
import { environment } from 'src/environments/environment';
import { EesePollResult } from 'src/app/graphQL/enums/graphql-eese-pool-result-enum';

@Injectable({
  providedIn: 'root'
})
export class VehicleFunctionsApiService {

  constructor(
    private apolloClientService: ApolloClientService,
    private http: HttpClient
  ) {}

  get(): Observable<VehicleFunction[]> {
    if (environment.IsHero)
      return of([]);

    return this.apolloClientService.apolloClient$.pipe(
          take(1),
          switchMap(client => {
            return client.query<{fileHandlerEeseGetDownloadPresignedUrl: string}>({
              query: GET_VEHICLE_FUNCTIONS_QUERY,
              variables: {EeseResultFor: EesePollResult.VHFCN}
            });
          }),
          map(results => {
            const url = results?.data?.fileHandlerEeseGetDownloadPresignedUrl;
            return url ?? '';
          }),
          switchMap(url => {
            return this.http.get<any[]>(url, { withCredentials: false });
          }),
          map(vehicleFunctions => {
            const mapped = (vehicleFunctions ?? []).map(vf => ({
              id: vf.id,
              name: vf.name,
              revision: vf.revision,
              vehicleSubFunctions: (vf.vehicleSubFunctions || []).map(vsf => ({
                id: vsf.id,
                name: vsf.name,
                revision: vsf.revision
              } as VehicleFunctionBase))
            } as VehicleFunction));
            return mapped;
          })
        );
  }
}
